/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AzureDevOpsListPipelinesRequest {
    getFixupPrototypeFunction() { return AzureDevOpsListPipelinesRequest.fixupPrototype; }

    static newInstance(model: Partial<AzureDevOpsListPipelinesRequest>): AzureDevOpsListPipelinesRequest {
        let obj = Object.assign(new AzureDevOpsListPipelinesRequest(), model);
        AzureDevOpsListPipelinesRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AzureDevOpsListPipelinesRequest>): AzureDevOpsListPipelinesRequest {
        if (!model) return null;
        return AzureDevOpsListPipelinesRequest.newInstance(<AzureDevOpsListPipelinesRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AzureDevOpsListPipelinesRequest) {
        if (!obj) return;

        models.AzureDevOpsListPipelinesRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AzureDevOpsListPipelinesRequest): boolean {
        Object.setPrototypeOf(obj, AzureDevOpsListPipelinesRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Service Account ID
     */
    service_account_id: string;

    /**
     * Azure Devops Project ID
     */
    project_id: string;

}
